import { ComponentProps } from 'react';

import { IntakeSummaryConnected } from '@grow-therapy-team/seedling-components';

import { useGetFormsByPatientShortId } from '../useGetFormsByPatientShortId';

type IntakeSummaryConnectedWithFormsPrefetchProps = ComponentProps<typeof IntakeSummaryConnected> & {
  patientShortId: string;
};

/**
 * Prefetches patient forms when the intake summary mounts so "View full intake"
 * can open the form response drawer without waiting on a network round-trip.
 */
export function IntakeSummaryConnectedWithFormsPrefetch({
  patientShortId,
  ...intakeSummaryProps
}: IntakeSummaryConnectedWithFormsPrefetchProps) {
  useGetFormsByPatientShortId(patientShortId);
  return <IntakeSummaryConnected {...intakeSummaryProps} />;
}
